import React, { useState } from 'react';
import MenuMain from '../../MenuMain';
import { AppFooter } from '../../AppFooter';
import { FormLoja } from '../../components/FormLoja';
import { ErrorRetrievingData } from '../../components/ErrorRetrievingData';

export default function CadastrarLojaPage() {
  const [isLoading] = useState(false);
  const [errorRetrievingData] = useState(false);
  const [errorMessage] = useState('');

  const defaultValues = {
    "lojistaId": null,
    "dataEmissao": "",
    "itens": "",
  }
  
  return (
    <div>
      <MenuMain>
        {
          errorRetrievingData ?
            <ErrorRetrievingData
              errorMessage={errorMessage}
              isLoading={isLoading}
            />
            :
            <FormLoja
              defaultValues={defaultValues}
              isLoading={isLoading}
              isEditing={false}
            />
        }
      </MenuMain>
      <AppFooter />
    </div>
  );
}

